<script lang="ts">
	import { goto } from '$app/navigation';
	import { browser } from '$app/environment';
	import { onMount } from 'svelte';
	import { getAuthorUsername } from '$lib/user';

	export let author: string = '';
	export let created_at: string | Date | undefined = undefined;
	export let prefix: string = 'by';
	export let prefixColor: string = '';

	let href: string = '';
	let authorUsername: string = '';

	// Format date
	const options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'long',
		year: 'numeric'
	};
	let postDate: Date;
	let postDateString: string = '';

	// Update postDateString reactively when created_at changes
	$: if (created_at) {
		postDate = new Date(created_at);
		postDateString = postDate.toLocaleDateString('en-US', options);
	}

	onMount(async () => {
		if (author) {
			authorUsername = await getAuthorUsername(author);
			href = `/member/${authorUsername}`;
		}
	});

	const handleNavAction = (navUrl: string) => {
		if (browser) goto(navUrl);
	};

	const textByline = 'text-sm sm:text-lg md:text-lg xl:text-xl';
</script>

<div
	role="button"
	aria-pressed="false"
	tabindex="0"
	class="{textByline} mt-0 md:mt-1 xl:mt-2 cursor-pointer gradient-green font-exo-2 text-left"
	on:click={() => handleNavAction(href)}
	on:keyup={(el) => {
		if (el.key === 'Enter') handleNavAction(href);
	}}
>
	<span class="text-xs sm:text-sm md:text-md 2xl:text-base text-left {prefixColor}"
		>{prefix} {author},</span
	>
	<span class="text-xs sm:text-sm md:text-md 2xl:text-base">{postDateString}</span>
</div>
